import {getUserConfig, getWeekDay} from '@utility/utils';

const data = getWeekDay(0)

const initialState = {
    list: [],
    total: 0,
    loading: false,
    searchParams: {
        clubID: "",
        clubNo: "",
        club_name: "",
        avatar_url: "",
        playerKeyword: "",
        gameID: 1005,
        orderBy: "roundTotal",
        orderType: "desc",
        start_date: data[0],
        end_date: data[1],
        page: 1,
        count: 30,
        refresh: false,
        ...getUserConfig("memberRecord")
    }
}

const memberRecord = (state = initialState, action) => {
    switch (action.type) {
        case 'MEMBER_RECORD':
            return {
                ...state,
                ...action.payload
            }
        case 'MEMBER_RECORD_INIT':
            return {
                ...initialState,
                searchParams: {
                    ...initialState.searchParams, ...getUserConfig("memberRecord")
                },
            }
        default:
            return {...state};
    }
}

export default memberRecord
